import React, { useState, useEffect } from 'react';
import { Empty, Table, message, Card, Spin, Row, Col, Skeleton } from 'antd'; // Typography
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom"
import { useExcryptedNavigation } from '../Filters/FilterConditions';
import { generateDynamicColumns, generateUsersTableData } from '../Pages/AllTableColumns/ContactTable';
import { StaffIcon, AccountsIcon } from '../../../components/Icons/Icons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { FetchDealByEntity } from "../../../Api/Services/CommonApiService";
import { FetchContactByAccount, FetchContactByDeal, FetchContactDetails } from "../../../Api/Services/ContactApiService";
import ContactColumns from '../Popup/ManageColumn'
import ContactColumnsFields from '../CustomColumn/ContactColumns.json'
import AddContactPage from '../Pages/AddCloneContactPage'

// const { Text } = Typography;

const ContactTable = ({ UrlId, listingType, refreshTrigger, tabKey, listingValues, setSelectedKeys, disabledData2, queryAction, EntityType, displayData, page, NacTrigger, setNaCTrigger }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const dispatch = useDispatch();
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        // const rawTime = converted.format("HH:mm");
        // const formattedTime = convertTime(rawTime, profile?.timeFormat);

        return formattedDate
    }
    const [createPage, setCratePage] = useState()
    const [dataForDeal, setDataForDeal] = useState()
    const [sortedInfo, setSortedInfo] = useState()
    const history = useHistory();
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const ViewDetailPage2 = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    // const [openPage, setOpenPage] = useState(Array(dealsList?.length).fill(false));
    const [contacts, setContacts] = useState()
    const [apiType, setApiType] = useState()
    const [customopen, setCustomopen] = useState(false)
    const [checkboxValues] = useState(ContactColumnsFields)
    const [configId] = useState()
    const contacttype = "CONTACT"
    // const handleOpenPageChange = (index) => {
    //     const newPopoverOpenStates = [...openPage];
    //     newPopoverOpenStates[index] = !newPopoverOpenStates[index];
    //     setOpenPage(newPopoverOpenStates);
    // };
    const createDeal = (Aid) => {
        setNaCTrigger("trigger")
        setCratePage("AccountPage")
        setDataForDeal({ AccountId: Aid })
    }
    async function getContactPersons(params) {
        try {
            const PersonArray = params.split(',').map(item => Number(item.trim()));
            const results = await Promise.all(
                PersonArray.map(async (PersonId) => {
                    const responseData = await FetchContactDetails(PersonId)
                    const Response = responseData.data
                    return { ...Response, DataPermission: { isPresent: responseData.allow } };
                })
            );
            setContacts(results);
        } catch (error) {
            message.error(error);
        }
    }
    async function AllContact() {
        if (apiType === "Account") {
            try {
                const response = await FetchContactByAccount(UrlId[1])
                const SortedData = response.sort((a, b) => b.contacts_id - a.contacts_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }
                        };
                    })
                );
                setContacts(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
        if (apiType === "Deal") {
            try {
                const response = await FetchContactByDeal(UrlId[1])
                const SortedData = response.sort((a, b) => b.contacts_id - a.contacts_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }
                        };
                    })
                );
                setContacts(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
        if (apiType === "Task") {
            try {
                const response = await FetchDealByEntity(UrlId[1], "Contact")
                const SortedData = response.sort((a, b) => b.contacts_id - a.contacts_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }
                        };
                    })
                );
                setContacts(dataWithCurrency)
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setStates({ ...states, selectedRowKeys, selectedRows });
            setSelectedKeys(selectedRowKeys)
        },
        getCheckboxProps: (record) => {
            const permission = record.SharingData
            if (record?.ContactDataForPermission?.approved_for !== "None") {
                return { disabled: true };
            }
            // Only apply permission checks for these actions
            if (["Update", "OwnerChange", "Delete", "Sharing"].includes(queryAction)) {
                if (!permission) return { disabled: false }; // Full access if no sharingPermission

                if (["Update", "OwnerChange"].includes(queryAction)) {
                    return { disabled: !permission.includes("Update") };
                }

                if (queryAction === "Delete") {
                    return { disabled: !permission.includes("Delete") };
                }

                if (queryAction === "Sharing") {
                    return { disabled: !permission.includes("Sharing") };
                }
            }
            return { disabled: false };
        }
    };
    const handleTableChange = async (_, _1, sorter) => {
        setSortedInfo(sorter)
    }
    const dynamicColumns = generateDynamicColumns(checkboxValues, ViewDetailPage, sortedInfo);
    const usersTableData = generateUsersTableData(contacts);
    async function getColumnConfig() {
        try {
            // const data = await getColumnConfigs("ContactTable");
            // if (data === "") {
            //     setCheckboxValues(ContactColumnsFields)
            //     setConfigId()
            // } else {
            //     setCheckboxValues(data.c_config)
            //     setConfigId(data.c_data_config_id)
            // }
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (listingType === "Query") {
            const SortedData = listingValues.sort((a, b) => b.contacts_id - a.contacts_id);
            const transformedData = SortedData.map(item => ({
                ...item,
                created_at: item.created_at ? convertAndFormatDateTime(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile) : "",
                modified_at: item.modified_at ? convertAndFormatDateTime(item.modified_time ? `${item.modified_at} ${item.modified_time}` : item.modified_at, companyProfile, profile) : "",
            }));
            setContacts(transformedData)
        }
    }, [listingType, listingValues])
    useEffect(() => {
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
            setApiType("Lead")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
            setApiType("Deal")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
            setApiType("Contact")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
            setApiType("Account")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
            setApiType("Task")
        }
    }, [])
    const fetchAll = async () => {
        await Promise.allSettled([
            AllContact(),
            getColumnConfig(),
        ])
    };
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (listingType !== "Query" && page !== "Deal") {
                fetchAll()
            }
            if (page === "Deal") {
                if (displayData?.contact_person) {
                    getContactPersons(displayData?.contact_person)
                }
                else {
                    setContacts([])
                }
            }
        }
    }, [UrlId, apiType, NacTrigger, displayData, refreshTrigger, tabKey])
    const TableSkeleton = () => {
        const skeletonRowStyle = {
            padding: '13px 20px',
            height: '68px',
            borderBottom: '1px solid #f0f0f0',
        };
        return (
            <div>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <div key={idx} style={skeletonRowStyle}>
                        <Skeleton
                            avatar paragraph={{ rows: 2, width: '100%' }}
                            active
                            title={false}
                        />
                    </div>
                ))}
            </div>
        );
    }; const LoadingCiolums = [
        {
            title: (
                <Skeleton
                    paragraph={{ rows: 1, width: '100%' }}
                    active
                    title={false}
                />
            ),
            dataIndex: 'name',
            key: 'name',
        },]
    return (
        <>
            {listingType === "Query" ?
                // <div className="full-width-table" style={{ width: "100%" }} >
                <div className='Listing-PagePadding' style={{ width: "100%" }}>
                    <Cards headless bodyStyle={{ borderRadius: '10px' }}>
                        <div className="table-bordered leaderboard-table table-responsive">
                            <Table
                                showSorterTooltip={false}
                                rowSelection={rowSelection}
                                dataSource={usersTableData}
                                columns={!contacts ? LoadingCiolums : dynamicColumns}
                                locale={{
                                    emptyText: !contacts ? (
                                        <TableSkeleton rows={5} />
                                    ) :
                                        contacts?.length === 0 && <Empty />
                                }}
                                onChange={handleTableChange}
                                pagination={{
                                    defaultPageSize: 5,
                                    total: usersTableData.length,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }} />
                        </div>
                    </Cards>
                </div > :
                <>
                    {(EntityType !== "Task" && page !== "Deal") ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginBottom: 15 }}>
                            <div className={disabledData2 ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                                role="button"
                                tabIndex={0} title='Add Resident'
                                onClick={disabledData2 ? undefined : () => createDeal(displayData?.account_id)}
                                onKeyDown={(event) => {
                                    if (disabledData2 && (event.key === 'Enter' || event.key === ' ')) {
                                        createDeal(displayData?.account_id)
                                    }
                                }}
                                aria-label='phone'
                            > <FeatherIcon icon="plus-circle" className="text_iconspace" size={16} />Add Resident</div>
                        </div>
                        : <></>}
                    <Row gutter={30}>
                        {contacts ? (contacts?.length > 0 ?
                            contacts?.map((item, index) => {
                                return (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                                        <div key={index} style={{ marginBottom: 15 }}
                                            className={item.DataPermission.isPresent ? "Card-click" : "Card-disabled"}
                                            role="button"
                                            tabIndex={0}
                                            onClick={item.DataPermission.isPresent ? () => ViewDetailPage2(item?.contacts_id, contacttype) : undefined}
                                            onKeyDown={(event) => {
                                                if (item.DataPermission.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                                                    ViewDetailPage2(item?.contacts_id, contacttype)
                                                }
                                            }}
                                            aria-label='phone'
                                        >
                                            <Card className="DetailsTabCard">
                                                <div style={{ padding: 10 }}>
                                                    <div className='user-info_image' style={{ marginBottom: 5, display: "flex", alignItems: "center", minWidth: 0, }}
                                                    > {item?.contact_profile !== null && item?.contact_profile
                                                        !== undefined && item?.contact_profile !== "" ?
                                                        <figure>
                                                            <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.contact_profile} alt="" />
                                                        </figure>
                                                        :
                                                        <span className='list_span_Tag ContactIcon' style={{ flexShrink: 0, }}>
                                                            {item?.first_name?.slice(0, 1).toUpperCase()}
                                                        </span>
                                                        }
                                                        <figcaption style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            overflow: "hidden", // 👈 keeps ellipsis responsive
                                                        }}>
                                                            <div style={{
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }} title={`${item?.first_name} ${item?.last_name}`}>
                                                                {`${item?.first_name} ${item?.last_name}`}
                                                            </div>
                                                            <div style={{
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }} title={item?.email} className='entityemail'>
                                                                {item?.email}
                                                            </div>
                                                        </figcaption>
                                                    </div>
                                                    <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                        <StaffIcon height={15} width={15} marginRight={5} />{item?.designation}
                                                    </div>

                                                    <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                        <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />
                                                        {(item?.mobile && item?.mobile !== "") ? item?.mobile : <span style={{ visibility: "hidden" }}>0</span>}
                                                    </div>
                                                    {UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK" ?
                                                        item?.account_id &&
                                                        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                            <AccountsIcon height={15} width={15} marginRight={5} />{item?.account_name}
                                                        </div>
                                                        : <></>}
                                                </div>
                                            </Card>
                                        </div >
                                    </Col>
                                )
                            }) :
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                <div style={{ padding: "10%" }}>
                                    <Empty />
                                </div>
                            </Col>
                        )
                            :
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                <div className="spin">
                                    <Spin />
                                </div>
                            </Col>
                        }</Row>
                </>
            }
            <AddContactPage UrlId={undefined} FromPage={createPage} setCratePage={setCratePage} dataForDeal={dataForDeal} CallBackTrigger={setNaCTrigger} />
            {customopen && <ContactColumns customopen={customopen} setCustomopen={setCustomopen} checkboxValues={checkboxValues} configId={configId} getColumnConfig={getColumnConfig} pageName="ContactTable" />}
        </>
    );
}
ContactTable.propTypes = {
    queryAction: PropTypes.string.isRequired,
    listingType: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    listingValues: PropTypes.array.isRequired,
    setSelectedKeys: PropTypes.func.isRequired,
    disabledData2: PropTypes.bool.isRequired,
    EntityType: PropTypes.string.isRequired,
    displayData: PropTypes.object.isRequired,
    page: PropTypes.string.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(ContactTable)